var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppDialog",
    {
      attrs: {
        title: "智能销售账号绑定",
        width: "518px",
        loading: _vm.loading,
        height: "auto",
        top: _vm.top,
      },
      on: { success: _vm.sure },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "editRemarks overflowOuto",
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              staticStyle: { "margin-top": "12px" },
              attrs: {
                "label-width": "auto",
                model: _vm.form,
                size: "small",
                rules: _vm.rules,
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "智能销售平台：", prop: "type" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "168px" },
                      attrs: { placeholder: "请选择", clearable: "" },
                      on: { change: _vm.onhandleTypeChang },
                      model: {
                        value: _vm.form.type,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "type", $$v)
                        },
                        expression: "form.type",
                      },
                    },
                    _vm._l(_vm.option, function (item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: {
                          label: item.name,
                          value: item.type,
                          disabled: _vm.handleDisabledFn(item.type),
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm.form.type === 2
                ? _c(
                    "el-form-item",
                    {
                      attrs: { label: "根据手机号绑定：", prop: "wechatPhone" },
                    },
                    [
                      !_vm.phone
                        ? _c("span", { staticClass: "tips" }, [
                            _vm._v("您还未填写员工手机号码，请先填写员工手机"),
                          ])
                        : !_vm.form.weChat.bizWechatName
                        ? _c("span", { staticClass: "tips" }, [
                            _vm._v("当前员工手机号码未对应到企业微信"),
                          ])
                        : _c(
                            "div",
                            { staticClass: "thirdAccountsListContent" },
                            [
                              _c(
                                "el-image",
                                {
                                  staticClass: "imgAvater",
                                  attrs: {
                                    src: _vm.form.weChat.bizWechatAvatar,
                                  },
                                },
                                [
                                  _c("template", { slot: "error" }, [
                                    _c("img", {
                                      staticStyle: {
                                        width: "100px",
                                        height: "100px",
                                      },
                                      attrs: {
                                        src: require("@/assets/image/imgloadError.png"),
                                        alt: "",
                                      },
                                    }),
                                  ]),
                                ],
                                2
                              ),
                              _c("div", { staticClass: "userInfo" }, [
                                _c("span", [
                                  _vm._v(_vm._s(_vm.form.weChat.bizWechatName)),
                                ]),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.form.weChat.bizWechatAlias)
                                  ),
                                ]),
                              ]),
                            ],
                            1
                          ),
                    ]
                  )
                : _vm._e(),
              _vm.form.type === 1
                ? _c(
                    "el-form-item",
                    { attrs: { label: "ERP员工编号：", prop: "erpCode" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          placeholder: "请输入",
                          maxlength: "50",
                          "show-word-limit": "",
                        },
                        on: { input: _vm.delNumber },
                        model: {
                          value: _vm.form.erpCode,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.form,
                              "erpCode",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "form.erpCode",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }